import React from "react";
import { Box, Link } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

export default function ScheduledEventTitle({ record, title, onOpenCandidate }) {
  const name = String(record.candidate_name || "").trim();
  const id = record.candidate_id;
  const label = title || record.event_title || name || "Interview";
  if (!id || Number(id) <= 0) return <>{label}</>;
  const candidateLink = <Link component={RouterLink} to={`/candidates?candidateId=${encodeURIComponent(String(id))}`}
    onClick={event => { event.stopPropagation(); onOpenCandidate?.(); }}
    onKeyDown={event => event.stopPropagation()}
    underline="always" color="inherit" sx={{ fontWeight: "inherit", "&:focus-visible": { outline: "2px solid currentColor", outlineOffset: 2 } }}>
    {name || "View candidate"}
  </Link>;
  const index = name ? label.indexOf(name) : -1;
  if (index >= 0) return <>{label.slice(0, index)}{candidateLink}{label.slice(index + name.length)}</>;
  return <>{label}<Box component="span" sx={{ display: "block", fontSize: "0.9em" }}>Candidate: {candidateLink}</Box></>;
}
